import { SET_CUSTOMER_PHONE } from 'actions';
import { IPhonePartial } from 'typings';

export function setCustomerPhone(customerPhone: IPhonePartial) {
  return { customerPhone, type: SET_CUSTOMER_PHONE };
}
